import { cn } from '@fc/ui'

/** The FC ChMS shield mark (matches the favicon). */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-7', className)} aria-hidden="true">
      <defs>
        <linearGradient id="fc-mark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--primary)" />
          <stop offset="1" stopColor="var(--secondary)" />
        </linearGradient>
      </defs>
      <path
        d="M16 5.5l8.5 4v6c0 5.2-3.6 8.7-8.5 10.5C11.1 24.2 7.5 20.7 7.5 15.5v-6L16 5.5z"
        fill="none"
        stroke="url(#fc-mark)"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path d="M16 11v8M12 15h8" stroke="url(#fc-mark)" strokeWidth={2} strokeLinecap="round" />
    </svg>
  )
}

/** Brand mark + wordmark lockup. */
export function BrandLockup({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <BrandMark />
      <span className="font-display text-lg font-bold tracking-tight">
        FC <span className="text-gradient">ChMS</span>
      </span>
    </span>
  )
}
